import React, { Component } from "react";
import { PageHeader } from "react-bootstrap";

import './style.css';

class Dashboard extends Component {

    constructor(props, context) {
        super(props, context);
    
        
        // this.handleChange = this.handleChange.bind(this);

    }

    render(){
        return(
            <div className="page-header">
                <h2 className="page-title">Dashboard</h2>
            </div>
        )
    }
}

export default Dashboard;